import { Observable } from 'rxjs';
import { Region, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable()
export class RegionService extends ApiService {
  endPoint = '/api/regions';
  create(model: Region) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: Region) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Region> {
    return this.http.get<Region>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getRegions(queryParams: any): Observable<DataSourceResponse<Region>> {
    const params = new HttpParamsEncoder().encode(queryParams);
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }

  getRegionsByCountryCode(countryCode: string): Observable<Region[]> {
    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}/country/${countryCode}/regions`);
  }
}
